import React, { useState } from "react";
import { Link } from "react-router-dom";
interface EditCreditCardDetailsProps {
  cardNumber: string;
  expiryDate: string;
  country: string;
  securityCode: string;
  cardHolderName: string;
}

export default function EditCreditCardDetails({
  cardNumber,
  expiryDate,
  country,
  securityCode,
  cardHolderName,
}: EditCreditCardDetailsProps) {
  const [cardDetails, setCardDetails] = useState({
    cardNumber: "",
    expiryDate: "",
    country: "",
    securityCode: "",
    cardHolderName: "",
  });
  return (
    <div>
      <div className="space-y-5">
        <div>
          <label htmlFor="cardNumber" className="secondary-text">
            Card number
          </label>
          <div className="input-field">
            <input
              defaultValue={cardNumber}
              onChange={(e) =>
                setCardDetails({ ...cardDetails, cardNumber: e.target.value })
              }
              type="text"
              name="cardNumber"
              required
              className="w-full"
            />
          </div>
        </div>
        <div>
          <label htmlFor="expiryDate" className="secondary-text">
            Expiry date
          </label>
          <div className="input-field">
            <input
              defaultValue={expiryDate}
              onChange={(e) =>
                setCardDetails({ ...cardDetails, expiryDate: e.target.value })
              }
              type="date"
              name="expiryDate"
              required
              className="w-full"
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3 w-full">
          <div>
            <label htmlFor="country" className="secondary-text">
              Country
            </label>
            <div className="input-field">
              <input
                defaultValue={country}
                onChange={(e) =>
                  setCardDetails({ ...cardDetails, country: e.target.value })
                }
                type="text"
                name="country"
                required
                className="w-full"
              />
            </div>
          </div>
          <div>
            <label htmlFor="securityCode" className="secondary-text">
              Security Code
            </label>
            <div className="input-field">
              <input
                defaultValue={securityCode}
                onChange={(e) =>
                  setCardDetails({
                    ...cardDetails,
                    securityCode: e.target.value,
                  })
                }
                type="text"
                name="securityCode"
                required
                className="w-full"
              />
            </div>
          </div>
        </div>
        <div>
          <label htmlFor="cardHolderName" className="secondary-text">
            Card name
          </label>
          <div className="input-field">
            <input
              defaultValue={cardHolderName}
              onChange={(e) =>
                setCardDetails({
                  ...cardDetails,
                  cardHolderName: e.target.value,
                })
              }
              type="text"
              name="cardHolderName"
              required
              className="w-full"
            />
          </div>
        </div>
      </div>
      <div className="mt-12">
        <Link
          to="/connected-cards"
          //   onClick={() => setTopup(!topup)}
          className="w-full left-0"
        >
          <button className="w-full font-medium">Save</button>
        </Link>
      </div>
    </div>
  );
}
